export const modal = {
    state: {
        modal: {
            state: false,
            type: '',
            data: [],
            currentItemIndex: null,
        },
    },
    getters: {
        getModal: state => state.modal.state,
        getModalType: state => state.modal.type,
        getModalData: state => state.modal.data,
        getCurrentItemIndex: state => state.modal.currentItemIndex,
    },
    mutations: {
        SAVE_MODAL_DATA(state, payload) {
            let modal = state.modal;
            for (let key in payload) {
                modal[key] = payload[key]
            }
        },
        CLOSE_MODAL(state){
            state.modal.state = false;
            state.modal.type = state.modal.data = '';
        }
    },
    actions: {
        SHOW_MODAL({commit}, {state, type, data, currentItemIndex}) {
            commit('SAVE_MODAL_DATA', {state, type, data, currentItemIndex})
        }
    }
}